import { FluentIconsProps, wrapIcon } from '@fluentui/react-icons';

export const TermsIcon = wrapIcon(
    (props: FluentIconsProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <path
                d="M5 2.5H12.5L15 5V17.5H5V2.5Z"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M7.5 8H12.5"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5 11H12.5"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 2.5V5H15"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'TermsIcon'
);